/**
 * PDP recommended-products upsell rows.
 * Color swatches pick the variant directly (updating price and image). For
 * products with other options, the Add button first reveals the variant
 * dropdown, then a second click adds to cart. The hidden <select> is the single
 * source of truth for the chosen variant. Adding dispatches `product:added` so
 * the cart drawer (or mini-cart) opens.
 */
(function () {
  function card(el) {
    return el.closest('[data-upsell-card]');
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-upsell-swatch]');

    if (swatch) {
      event.preventDefault();

      var swatchHost = card(swatch);
      var swatchSelect = swatchHost && swatchHost.querySelector('[data-upsell-variant-select]');

      if (swatchSelect) {
        swatchSelect.value = swatch.getAttribute('data-variant-id');
        sync(swatchHost, swatchSelect);
      }

      return;
    }

    var button = event.target.closest('[data-upsell-action]');

    if (!button) {
      return;
    }

    var action = button.getAttribute('data-upsell-action');

    if (action === 'reveal-options') {
      event.preventDefault();

      var host = card(button);
      var select = host && host.querySelector('[data-upsell-variant-select]');

      button.setAttribute('data-upsell-action', 'add-item');
      button.textContent = button.getAttribute('data-add-label') || 'Add';

      if (select) {
        select.hidden = false;
        sync(host, select);
      }
    } else if (action === 'add-item') {
      event.preventDefault();
      addItem(button);
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-upsell-variant-select]');
    var host = select && card(select);

    if (host) {
      sync(host, select);
    }
  });

  // Reflects the selected <option> on the row: button, price, image, swatches.
  function sync(host, select) {
    var option = select.options[select.selectedIndex];

    if (!option) {
      return;
    }

    var button = host.querySelector('[data-upsell-action]');
    if (button) {
      button.setAttribute('data-variant-id', option.value);

      // Before the dropdown is revealed the button must stay clickable.
      if (button.getAttribute('data-upsell-action') === 'add-item') {
        button.disabled = option.disabled;
      }
    }

    var priceEl = host.querySelector('[data-upsell-price]');
    if (priceEl && option.dataset.price) {
      priceEl.textContent = option.dataset.price;
    }

    var compareEl = host.querySelector('[data-upsell-compare]');
    if (compareEl) {
      if (option.dataset.compare) {
        compareEl.textContent = option.dataset.compare;
        compareEl.hidden = false;
        if (priceEl) priceEl.classList.add('price--highlight');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        if (priceEl) priceEl.classList.remove('price--highlight');
      }
    }

    var img = host.querySelector('.product-upsell__image img');
    if (img && option.dataset.image) {
      img.src = option.dataset.image;
      img.removeAttribute('srcset');
    }

    if (option.dataset.color !== undefined) {
      host.querySelectorAll('[data-upsell-swatch]').forEach(function (swatch) {
        var checked = swatch.getAttribute('data-upsell-swatch') === option.dataset.color;
        swatch.setAttribute('aria-checked', checked ? 'true' : 'false');
      });
    }
  }

  function addItem(button) {
    var id = parseInt(button.getAttribute('data-variant-id'), 10);

    if (!id) {
      return;
    }

    var host = card(button);
    var addUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add';

    button.setAttribute('disabled', 'disabled');
    if (host) host.classList.add('is-adding');

    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) {
        return response.ok ? response.json() : Promise.reject();
      })
      .then(function () {
        if (host) {
          host.classList.remove('is-adding');
          host.classList.add('is-added');
        }

        // Opens the cart drawer (or mini-cart) with the newly added item.
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true }));

        setTimeout(function () {
          if (host) host.classList.remove('is-added');
          button.removeAttribute('disabled');
        }, 900);
      })
      .catch(function () {
        if (host) host.classList.remove('is-adding');
        button.removeAttribute('disabled');
      });
  }
})();
